/** Runtime provenance, never a saved selection. A confirmed absent row may
 * reveal a control; only an explicit durable tool action authors a selection.
 * Legacy snapshots have no provenance and are conservatively explicit.
 */
export type ToolSharingSelectionIntent = 'unresolved' | 'implicit-background' | 'explicit';
export function canPersistToolSharing(state: { selectionIntent?: unknown } | null | undefined): boolean {
  return !!state && state.selectionIntent !== 'unresolved' && state.selectionIntent !== 'implicit-background';
}
